import { Button } from '@aqarmap/aqarmap-ui';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Location, {
  LocationSearchType,
} from '~/modules/addListing/pages/InitializeStep/Location';
import { EvaluationSteps } from '~valuation/enums';

const LocationStep = ({
  setActiveStep,
}: {
  setActiveStep: React.Dispatch<React.SetStateAction<number>>;
}) => {
  const { t } = useTranslation('app');
  const {
    setValue,
    clearErrors,
    formState: { errors },
    trigger,
    watch,
  } = useFormContext<LocationSearchType>();

  const isValid = watch('location');

  const handleNext = async () => {
    const valid = await trigger(['location', 'centerLat', 'centerLng']);

    if (!valid) return;
    setActiveStep(EvaluationSteps.PROPERTY_DETAILS);
  };

  return (
    <div className="flex flex-col gap-3x md:gap-8x">
      <div className="flex flex-col gap-3x px-2x md:px-0">
        <p className="text-lg text-title_3 text-black">{t('locationTitle')}</p>
        <Location
          setValue={setValue}
          errors={errors}
          clearErrors={clearErrors}
          allowSelectAllLocations
          hideSuggestLocation
        />
      </div>
      <div className="flex pt-3x px-2x md:px-3x border-t border-gray w-full gap-1.5x md:gap-5x">
        <Button
          variant="primary"
          size="medium"
          disabled={!isValid}
          className="text-link w-full max-w-[270px]"
          onClick={() => handleNext()}
        >
          {t('next')}
        </Button>
        <Button
          variant="secondary"
          size="medium"
          className="text-link w-full max-w-[270px]"
          onClick={() => setActiveStep(EvaluationSteps.GOAL)}
        >
          {t('back')}
        </Button>
      </div>
    </div>
  );
};

export default LocationStep;
